import { Box } from '@factorialco/deprecated-design-system'

import { SkeletonValue } from 'modules/finance/components/FinancialWorkspace/components/SkeletonValue'

export const Loading = ({ itemsPerPage }: { itemsPerPage: number }) => {
  return (
    <Box flexDirection="column" gap="s8" paddingTop="s8">
      {Array.from({ length: itemsPerPage }).map((_, index) => (
        <Box key={index} background="grey000White" padding="s12" borderRadius={{ all: 'abs008' }}>
          <SkeletonValue width="s240" />
        </Box>
      ))}
    </Box>
  )
}
